import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/jobstream.webp';
import screenshot_target from '../../../images/letterfunnel/sanderklos.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Sander Klos"
      firstname="Sander"
      companyname="Jobstream"
      competition="Wonderkind en Mr.Work"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/sanderklos.js